import React, { Component, Fragment } from 'react';
import { CustomLoading, Loading } from './LoadingComponent';
import { connect } from 'react-redux';
import { Breadcrumb, BreadcrumbItem, Label, Input, Button } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { aggregate, sort_by, unique_values, pick, transpose, CustomListSelect } from './Functions';
import { RenderVirtualTable } from './TableComponent';
import { PiePlot, MultBarPlot, BarPlot, ScatterPlot, MultLineTsPlot } from './PlotComponent';
import { colors_sura } from '../shared/data';

// import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    port_metrics: state.port_metrics,
    fx_metrics: state.fx_metrics,
    backtest_params: state.backtest_params
  };
};

class PortMetrics extends Component {
  constructor(props){
      super(props);
      this.state = {
        msg:null,
        tra_agg:true,
        port_name:null
      };
      this.header = this.header.bind(this);
  }
  
  header(){
    return(
      <>
        <div className="row mt-5 justify-content-center">
          <div className="col-auto">
              <h4>Backtesting</h4>
          </div>
        </div>
        <div className="row m-3 justify-content-center">
          <div className="col-auto">
            <Breadcrumb>
              <BreadcrumbItem><Link to='/portfolio/backtest/params'>Parámetros</Link></BreadcrumbItem>
              <BreadcrumbItem active>Resultados</BreadcrumbItem>
            </Breadcrumb>
          </div>
        </div>
      </>
      );
  }

  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Loading />
            </div>
          </div>
        );
      } else if(this.props.port_metrics.errMess){
          return(
              <div className="container">
                {this.header()}
                <div className="row justify-content-center">
                    <h6>{this.props.port_metrics.errMess}</h6>
                </div>
              </div>
          );
      } else if(this.props.port_metrics.isLoading){
          return(
              <div className="container">
                {this.header()}
                <div className="row justify-content-center">
                  <CustomLoading msg="calculando métricas" icon="fa-calculator"/>
                </div>
              </div>
          );
      } else if (this.props.port_metrics.data==null){
          return(
            <div className='container'>
              {this.header()}
              <div className="row justify-content-center m-5">
                  <h6>No hay datos disponibles.</h6>
              </div>
            </div>
          );
      } else if (this.props.port_metrics.data?.port!=null || this.props.port_metrics.data?.bench!=null) {
        const port_alloc = this.props.port_metrics.data.port;
        const bench_alloc = this.props.port_metrics.data.bench;
        const tra_asset = this.props.port_metrics.data.tra_asset==null ? null : this.state.tra_agg ?
                          aggregate(this.props.port_metrics.data.tra_asset, ['Clase de Activo'], Object.keys(this.props.port_metrics.data.tra_asset[0]).filter(k=>!['Activo', 'Clase de Activo'].includes(k))).sort(sort_by('Portafolio')) :
                          this.props.port_metrics.data.tra_asset.map(({['Clase de Activo']: _, ...rest }) => rest);
        const tra_asset_filter = tra_asset==null ? null : [...tra_asset].sort(sort_by('Total')).map(item=>{
                                    return {'Asset':this.state.tra_agg ? item['Clase de Activo'] : item.Activo, Total:item.Total};
                                  });
        return (
          <div className="container">
            {this.header()}
            <div className="row m-5 justify-content-center">
              <div className='col' id="alloc">
                <h5>Asignación de Activos</h5>
                <a className='linkcol' href='#risk'>riesgo-retorno&darr;</a>
                <a className='linkcol' href='#contrib'>{"       "}contribución&darr;</a>
                <a className='linkcol' href='#attrib'>{"       "}atribución&darr;</a>
              </div>
            </div>
            <div className="row m-5 justify-content-center">
              <div className='col-6'>
                <h6>{this.props.port_metrics.data.port_name || (port_alloc.length==1 ? port_alloc[0].Activo : "Portafolio")}</h6>
                <p><small>{this.props.port_metrics.data.port_date || "------"}</small></p>
                <PiePlot 
                  data={port_alloc}
                  legend={true}
                  percTooltip={true}
                  legendHeight={150}
                  width={550}
                  height={500}
                  outerRadius={100}
                  dataKey="w"
                  nameKey="Activo"
                />
              </div>
              {bench_alloc!==null ?
              <div className='col-6'>
                <h6>{this.props.port_metrics.data.bench_name || (bench_alloc.length==1 ? bench_alloc[0].Activo : "Benchmark")}</h6>
                <p><small>{this.props.port_metrics.data.bench_date || "------"}</small></p>
                <PiePlot 
                  data={bench_alloc}
                  legend={true}
                  percTooltip={true}
                  legendHeight={150}
                  width={550}
                  height={500}
                  outerRadius={100}
                  dataKey="w"
                  nameKey="Activo"
                />
              </div>
              :null
              }
            </div>
            
            {true ? // Riesgo - retorno
            <>
              <div className="row m-5 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>
              <div className="row mt-5 justify-content-center">
                <div className='col' id="risk">
                  <h5>Riesgo - Retorno</h5>
                  <a className='linkcol' href='#alloc'>allocation&uarr;</a>
                  <a className='linkcol' href='#contrib'>{"       "}contribución&darr;</a>
                  <a className='linkcol' href='#attrib'>{"       "}atribución&darr;</a>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className='col'>
                  <small>{this.props.port_metrics.data.dates[0]}/{this.props.port_metrics.data.dates[1]}</small>
                </div>
              </div>
              <div className="row mt-5 align-items-start">
                <div className='col-md-6'>
                  <div className='row justify-content-center'>
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={this.props.port_metrics.data.rets_summ} 
                        to_perc={[false, true, true]}
                        to_perc_row={[true, true, true, true, true, true, false, true, false, false, true]}
                        cell_width={['200px', "100px", '100px']}
                        item_size={30}
                        style="black"
                        />
                    </div>
                  </div>
                  <div className='row justify-content-center'>
                    <div className='col-auto'>
                      <CSVLink className='link-btn' data={this.props.port_metrics.data.rets_summ} filename="metrics"><small>descargar métricas&darr;</small></CSVLink>
                    </div>
                    <div className='col-auto'>
                      <CSVLink className='link-btn' data={this.props.port_metrics.data.series} filename="series"><small>descargar series&darr;</small></CSVLink>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <MultLineTsPlot data={this.props.port_metrics.data.series}
                     width={500}
                     height={500}
                     xkey='Fecha'
                     ykeys={this.props.bench_name!==null ? ["Portafolio", "Benchmark"] : ["Portafolio"]}
                     xtype='category'
                     ytype='number'
                     colors = {['#000000']}
                     percTooltip={false}
                     legend={true ? this.props.port_metrics.data.bench_name : false}
                     ml={50}
                     top={20}
                  />
                </div>
              </div>
              <div className="row m-4 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>
            </>
            :<></>
            }
            {/*Contribution*/}
          {true ? // Riesgo - retorno
            <>
              <div className="row mt-5 justify-content-center">
                <div className='col' id="contrib">
                  <h5>Análisis de Contribución</h5>
                  <a className='linkcol' href='#alloc'>allocation&uarr;</a>
                  <a className='linkcol' href='#risk'>{"       "}riesgo-retorno&uarr;</a>
                  <a className='linkcol' href='#attrib'>{"       "}atribución&darr;</a>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className='col'>
                  <small>{this.props.port_metrics.data.dates[0]}/{this.props.port_metrics.data.dates[1]}</small>
                </div>
              </div>
              <div className="row mt-5 justify-content-center">
                <div className='col-9'>
                  <h6>Retorno Total</h6>
                </div>
              </div>
              <div className="row m-4 align-items-start">
                <div className='col-md-6'>
                  <div className='row justify-content-center'>
                    <div className="col-auto">
                      <RenderVirtualTable 
                        data={this.props.port_metrics.data.tr_contrib.sort(sort_by(['Portafolio', "Benchmark"], "desc"))} 
                        to_perc={[false, true, true]}
                        cell_width={['250px', '100px', '100px']}
                        item_size={40}
                        fontsize={12}
                        style="black"
                        />
                    </div>
                  </div>
                  <div className='row justify-content-center mt-5'>
                    <div className='col-10'>
                      <CSVLink className='link-btn' data={this.props.port_metrics.data.tr_contrib} filename="metrics"><small>Descargar contribución de retorno &darr;</small></CSVLink>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <MultBarPlot 
                    data={this.props.port_metrics.data.tr_contrib}
                    nameKey='Activo'
                    vertical={true}
                    angle={0}
                    ytype="category" xtype="number"
                    colors={["#000000", "#2803fc"]}
                    xpercAxis={true}
                    moneyTooltip={false}
                    percTooltip={true}
                    width={500}
                    interval={0}
                    height={500}
                    barsize={5}
                    top={20}
                    fontsize={12}
                  />
                </div>
              </div>
              <div className="row mt-5 justify-content-center">
                <div className='col'>
                  <h6>Riesgo</h6>
                </div>
              </div>
              <div className="row m-4 align-items-start">
                <div className='col-md-6'>
                  <div className='row justify-content-center'>
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={this.props.port_metrics.data.risk_contrib.map(item=>{
                          return {"Activo":item.Activo, "Contribución Vol.": item["Contribución Vol."], "Contribución Vol. %":item["Contribución Vol. %"]}
                        })} 
                        to_perc={[false, true, true]}
                        cell_width={['250px', '100px', '100px']}
                        item_size={40}
                        style="black"
                        />
                    </div>
                  </div>
                  <div className='row m-5'>
                    <div className='col'>
                      <CSVLink 
                        className='link-btn' 
                        data={this.props.port_metrics.data.risk_contrib.map(item=>{
                          return {Portafolio:"Portafolio", ...item};
                        }).concat(this.props.port_metrics.data?.risk_contrib_bench ? this.props.port_metrics.data?.risk_contrib_bench.map(item=>{
                          return {Portafolio:"Benchmark", ...item};
                        }) : [])} 
                        filename="metrics"
                      ><small>Descargar contribución de riesgo &darr;</small></CSVLink>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <MultBarPlot 
                    data={this.props.port_metrics.data.risk_contrib.map(item=>{
                      return {'Activo':item.Activo, 'Contribución Vol.':item['Contribución Vol.']}
                    })}
                    nameKey='Activo'
                    vertical={true}
                    angle={0}
                    ytype="category" xtype="number"
                    colors={["#000000", "#2803fc"]}
                    xpercAxis={true}
                    moneyTooltip={false}
                    percTooltip={true}
                    width={500}
                    interval={0}
                    height={500}
                    barsize={8}
                    top={20}
                    legend={false}
                    fontsize={12}
                  />
                </div>
              </div>
            </>
            :<></>
            }

            {/*Attribution*/}
            {this.props.port_metrics.data.tra_asset!==null ? // Riesgo - retorno
            <>
              <div className="row m-4 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>
              <div className="row mt-5 justify-content-center">
                <div className='col' id="attrib">
                  <h5>Análisis de Atribución</h5>
                  <a className='linkcol' href='#alloc'>allocation&uarr;</a>
                  <a className='linkcol' href='#risk'>{"       "}riesgo-retorno&uarr;</a>
                  <a className='linkcol' href='#contrib'>{"       "}contribución&uarr;</a>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className='col'>
                  <small>{this.props.port_metrics.data.dates[0]}/{this.props.port_metrics.data.dates[1]}</small>
                </div>
              </div>
              <div className='row m-4 justify-content-center'>
                <div className='col-2'>
                  <Label check>
                    <Input type="checkbox"
                      checked={this.state.tra_agg}
                      onChange={()=>this.setState({tra_agg:!this.state.tra_agg})}
                      />
                      <small>{'   '}Clase de Activo</small>
                  </Label>
                </div>
              </div>
              <div className="row mt-5 align-items-start">
                <div className='col-md-6'>
                  <div className='row justify-content-center'>
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={tra_asset} 
                        to_perc={[false].concat(new Array(10).fill(true))}
                        cell_width={['150px'].concat(new Array(10).fill('60px'))}
                        item_size={40}
                        fontsize={11}
                        style="black"
                        />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <CSVLink className='link-btn' data={this.props.port_metrics.data.tra_asset} filename="metrics"><small>Descargar atribución de retorno &darr;</small></CSVLink>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <MultBarPlot 
                    data={tra_asset_filter}
                    nameKey='Asset'
                    vertical={true}
                    angle={0}
                    ytype="category" xtype="number"
                    colors={["#000000", "#2803fc"]}
                    xpercAxis={true}
                    moneyTooltip={false}
                    percTooltip={true}
                    width={500}
                    interval={0}
                    height={this.state.tra_agg ? 400 : 500}
                    barsize={this.state.tra_agg ? 20 : 8}
                    fontsize={12}
                    legend={false}
                  />
                </div>
              </div>
            </>
            :<></>
            }
          </div>
        );
      } else if (this.props.port_metrics.data.weights_ports!==null || this.props.port_metrics.data.weights_benchs!==null) {
        const port_names = unique_values(this.props.port_metrics.data.weights_ports, "Portafolio");
        const port_alloc = this.props.backtest_params.port_name==null || this.props.backtest_params.port_name=="" ? null : 
                           this.props.port_metrics.data.weights_ports.filter(item=>item.Portafolio==this.props.backtest_params.port_name).map(item=>{
                             return {Activo:item.Activo, Portafolio:100*item.Peso}
                           });
        const bench_alloc = this.props.backtest_params.port_name==null || this.props.backtest_params.port_name=="" || this.props.port_metrics.data.weights_benchs==null  ? null : 
                            this.props.port_metrics.data.weights_benchs.filter(item=>item.Portafolio==this.props.backtest_params.port_name.replace(" - Tactico", "")).map(item=>{
                              return {Activo:item.Activo, Benchmark:100*item.Peso}
                            });
      

        const valid_metrics = ["Retorno Promedio Anual.","Volatilidad Anual.", "VeR 99%", "Duración", "Sharpe", "Drawdown"];

        const rets_summ_table = transpose(
          this.props.port_metrics.data.metrics_summ_df.filter(item=>valid_metrics.includes(item["Métrica"])).map(item => pick(item, ['Métrica'].concat(port_names)))
        , "Métrica", "Portafolio");
        
        const tra_agg = this.props.port_metrics.data.tra_asset==null ? null : 
                          aggregate(this.props.port_metrics.data.tra_asset, ["Nombre Port"], ["AA", "SS", "Inter.", "Total"]).sort(sort_by('Total'));

        // const valid_pat_keys =  ["Nombre Port", "Activo", "Portafolio", "Benchmark", "Desvación Promedio", "AA", "SS", "Total"]

        // const tra_asset = this.props.port_metrics.data.tra_asset==null ? null : this.state.tra_agg ?
        //                   aggregate(this.props.port_metrics.data.tra_asset, ['Clase de Activo'], Object.keys(this.props.port_metrics.data.tra_asset[0]).filter(k=>!['Activo', 'Clase de Activo'].includes(k))).sort(sort_by('Portafolio')) :
        //                   this.props.port_metrics.data.tra_asset.map(item=>pick(item, valid_pat_keys));

        return (
          <div className="container">
            {this.header()}
            <div className="row m-5 justify-content-center">
              <div className='col' id="alloc">
                <h5>Asignación de Activos</h5>
                <a className='linkcol' href='#risk'>riesgo-retorno&darr;</a>
                <a className='linkcol' href='#attrib'>{"       "}atribución&darr;</a>
              </div>
            </div>
            <div className="row m-5 justify-content-center">
              <div className='col-4'>
                <CustomListSelect
                  maxMenuHeight={150}
                  options={port_names.map(x=>{
                    return {value:x, label:x};
                  })}
                  isClearable={true}
                  value={{value:this.props.backtest_params.port_name, label:this.props.backtest_params.port_name}}
                  onChange={(e)=>this.props.changeModel("backtest_params.port_name", e?.value)}
                  itemSize={50}
                  className="basic-single"
                  fontsize={12}
                  placeholder="Seleccionar portafolio..."
                />
              </div>
            </div>
            <div className="row m-5 justify-content-center">
              {port_alloc!==null && (bench_alloc==null || bench_alloc.length==0)?
                <div className='col-md-6'>
                  <h6>Portafolio</h6>
                  <PiePlot 
                    data={port_alloc}
                    legend={true}
                    percTooltip={true}
                    legendHeight={150}
                    width={550}
                    height={500}
                    outerRadius={100}
                    dataKey="Portafolio"
                    nameKey="Activo"
                  />
                </div>
              : port_alloc && bench_alloc ?
                <>
                  <div className='col-md-6'>
                    <BarPlot 
                      x={port_alloc.sort(sort_by("Portafolio", 'desc')).map(x=>x.Portafolio)}
                      y={port_alloc.sort(sort_by("Portafolio", 'desc')).map(x=>x.Activo)}
                      layout="vertical"
                      angle={0}
                      ytype="category" xtype="number"
                      color={"#000000"}
                      xpercAxis={true}
                      percTooltip={true}
                      width={500}
                      ml={220}
                      interval={0}
                      height={400}
                      barsize={15}
                      fontsize={11}
                      top={0}
                    />
                  </div>
                  <div className='col-md-6'>
                    <BarPlot 
                      x={bench_alloc.sort(sort_by("Benchmark", 'desc')).map(x=>x.Benchmark)}
                      y={bench_alloc.sort(sort_by("Benchmark", 'desc')).map(x=>x.Activo)}
                      layout="vertical"
                      angle={0}
                      ytype="category" xtype="number"
                      color="#2803fc"
                      xpercAxis={true}
                      percTooltip={true}
                      width={500}
                      ml={220}
                      interval={0}
                      height={400}
                      barsize={15}
                      fontsize={11}
                      top={0}
                    />
                  </div>
                </>
              :<div className='col-auto'>
                <h6>Seleccionar portafolio...</h6>
              </div>
              }
            </div>

            {true ? // Riesgo - retorno
            <>
              <div className="row m-5 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>
              <div className="row mt-5 justify-content-center">
                <div className='col' id="risk">
                  <h5>Riesgo - Retorno</h5>
                  <a className='linkcol' href='#alloc'>allocation&uarr;</a>
                  <a className='linkcol' href='#attrib'>{"       "}atribución&darr;</a>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className='col'>
                  <small>{this.props.port_metrics.data.dates[0]}/{this.props.port_metrics.data.dates[1]}</small>
                </div>
              </div>
              <div className="row m-5 justify-content-center">
                <div className='col-6'>
                  <div className="row justify-content-center">
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={rets_summ_table} 
                        to_perc={[false, true, true, false, true, false, true]}
                        cell_width={["200px", '60px', '60px', '60px', '60px', '60px', '60px']}
                        item_size={40}
                        fontsize={12}
                        style="black"
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <CSVLink className='link-btn' data={rets_summ_table} filename="rets_summ_table"><small>Descargar métricas &darr;</small></CSVLink>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  {/*
                  <div className="row justify-content-center">
                    <div className='col-auto'>
                      <ButtonGroup size='sm'>
                        <Button
                          color="secondary"
                          outline
                          onClick={() => this.setState({show_series:!this.state.show_series})}
                          active={this.state.show_series}
                        >
                          series
                        </Button>
                        <Button
                          color="secondary"
                          outline
                          onClick={() => this.setState({show_series:!this.state.show_series})}
                          active={!this.state.show_series}
                        >
                          riesgo-retorno
                        </Button>
                      </ButtonGroup>
                    </div>
                  </div>
                  */
                  }
                  <div className="row m-2">
                    {false ? //this.state.show_series ?
                      <div className='col-auto'>
                        <MultLineTsPlot data={this.props.port_metrics_compar.data.series}
                         width={600}
                         height={450}
                         xkey='Date'
                         ykeys={this.props.port_metrics_compar.data.names}
                         xtype='category'
                         ytype='number'
                         colors = {colors_sura}
                         percTooltip={false}
                         legend={true ? this.props.port_metrics_compar.data.names.length > 1 : false}
                         ml={50}
                        />
                      </div>
                    :
                      <div className='col-6'>
                        <ScatterPlot
                          data={rets_summ_table}
                          color="#000000"
                          xlabel="Volatilidad"
                          ylabel="Retorno Promedio"
                          xAxisId="Volatilidad Anual."
                          yAxisId="Retorno Promedio Anual."
                          zAxisId='Portafolio'
                          dataName='Portafolio'
                          width={580}
                          ml={50}
                          showLabels={true}
                          percTooltip={true}
                          xpercAxis={true}
                          ypercAxis={true}
                          legend={false}
                        />
                      </div>
                    }
                  </div>
                </div>
              </div>

            </>
            :<></>
            }

            {/*Attribution*/}
            {tra_agg ? //this.props.port_metrics.data.tra_asset!==null ? // Riesgo - retorno
            <>
              <div className="row m-4 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>
              <div className="row mt-5 justify-content-center">
                <div className='col' id="attrib">
                  <h5>Análisis de Atribución</h5>
                  <a className='linkcol' href='#alloc'>allocation&uarr;</a>
                  <a className='linkcol' href='#risk'>{"       "}riesgo-retorno&uarr;</a>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className='col'>
                  <small>{this.props.port_metrics.data.dates[0]}/{this.props.port_metrics.data.dates[1]}</small>
                </div>
              </div>
              <div className='row m-5 justify-content-center'>
                <div className='col-auto'>
                  <RenderVirtualTable 
                    data={tra_agg} 
                    to_perc={[false].concat(new Array(10).fill(true))}
                    cell_width={['200px'].concat(new Array(4).fill('80px'))}
                    item_size={40}
                    fontsize={11}
                    style="black"
                    />
                </div>
              </div>
              {/*
              <div className='row m-4 justify-content-center'>
                <div className='col-2'>
                  <Label check>
                    <Input type="checkbox"
                      checked={this.state.tra_agg}
                      onChange={()=>this.setState({tra_agg:!this.state.tra_agg})}
                      />
                      <small>{'   '}Clase de Activo</small>
                  </Label>
                </div>
              </div>
              <div className="row m-5 align-items-start">
                <div className='col-md-6'>
                  <div className='row justify-content-center'>
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={tra_asset} 
                        to_perc={[false].concat(new Array(10).fill(true))}
                        cell_width={['100px'].concat(new Array(10).fill('65px'))}
                        item_size={40}
                        fontsize={11}
                        style="black"
                        />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <CSVLink className='link-btn' data={this.props.port_metrics.data.tra_asset} filename="metrics"><small>Descargar atribución de retorno &darr;</small></CSVLink>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <MultBarPlot 
                    data={tra_asset.sort(sort_by('Total')).map(item=>{
                      return {'Key':this.state.tra_agg ? item['Clase de Activo'] : item.Activo, Total:item.Total}
                    })}
                    nameKey='Key'
                    vertical={true}
                    angle={0}
                    ytype="category" xtype="number"
                    colors={["#000000", "#2803fc"]}
                    xpercAxis={true}
                    moneyTooltip={false}
                    width={500}
                    ml={150}
                    interval={0}
                    height={this.state.tra_agg ? 400 : 500}
                    barsize={this.state.tra_agg ? 20 : 8}
                    fontsize={12}
                    legend={false}
                  />
                </div>
              </div>
              */}
            </>
            :<></>
            }
          </div>
        );
      }
      
      
      
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(PortMetrics));